/* eslint-disable camelcase */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import {
  Form,
  upperAndLowerCaseValidator,
  minLengthValidator,
  digitsValidator,
  specialCharValidator,
  Modal,
} from 'cvlib';
import ModalError from './ModalError';
import { useSelector } from 'react-redux';
import { getClaroAdsKey } from 'utils/claroAds/getClaroAdskey';

const PasswordForm = props => {
  const {
    register_password_title_label,
    register_password_description_label,
    register_password_option_button_next,
    register_password_option_button_cancel,
    password_tooltip_completeField_label_validation,
    password_tooltip_title_label,
    password_tooltip_letter_label_validation,
    password_tooltip_number_label_validation,
    password_tooltip_length_label_validation,
    password_tooltip_specialCharacters_label_validation,
  } = props.translations;

  const {
    generic_tooltip_pattern_checkmark_yes,
    generic_tooltip_pattern_checkmark_no,
  } = props.asset;

  const { onNextClicked, onCancelClicked, registerError, onCloseModal } = props;
  const [passwordValue, setPasswordValue] = useState('');
  const [showErrorAsNeutral, setShowErrorAsNeutral] = useState(true);
  const claroAdEnable = useSelector(state => getClaroAdsKey(state));
  const satisfyPassword = R.allPass([
    upperAndLowerCaseValidator,
    minLengthValidator(8),
    digitsValidator,
    R.allPass([R.complement(specialCharValidator), minLengthValidator(1)]),
  ]);
  const elements = [
    {
      element: 'title',
      content: register_password_title_label,
    },
    {
      element: 'subtitle',
      content: register_password_description_label,
      position: 'top',
      expand: claroAdEnable ? 1.5 : 0
    },
    {
      element: 'item',
      type: 'password',
      name: 'password',
      id: 'password',
      autoFocus: true,
      expand: 2,
      header: password_tooltip_title_label,
      successIcon: generic_tooltip_pattern_checkmark_yes,
      errorIcon: generic_tooltip_pattern_checkmark_no,
      message: {
        upperAndLower: password_tooltip_letter_label_validation,
        digits: password_tooltip_number_label_validation,
        minLength: password_tooltip_length_label_validation,
        specialChar:
          password_tooltip_specialCharacters_label_validation ||
          'password_tooltip_specialCharacters_label_validation',
      },
      registerOptions: {
        required: password_tooltip_completeField_label_validation,
      },
      onChange: ({ target }) => {
        setPasswordValue(target.value);
        setShowErrorAsNeutral(true);
      },
      showErrorAsNeutral,
    },
    {
      element: 'button',
      type: 'red',
      content: register_password_option_button_next,
      submit:
        satisfyPassword(passwordValue) === true
          ? onNextClicked
          : () => setShowErrorAsNeutral(false),
      dimmed: !satisfyPassword(passwordValue),
    },
    {
      element: 'button',
      type: 'gray',
      content: register_password_option_button_cancel,
      onClick: onCancelClicked,
      expand: claroAdEnable ? 0.2 : 2,
      position: 'top',
    },
    claroAdEnable ? 
    [{
      element: 'title',
      expand: 4,
    }] : [],
  ];

  return (
    <div>
      <Form elements={elements} />
      <Modal isOpen={registerError} classNames={[]}>
        <ModalError
          error_message={props.translations[registerError]}
          translations={props.translations}
          asset={props.asset}
          onCloseModal={onCloseModal}
        />
      </Modal>
    </div>
  );
};

PasswordForm.propTypes = {
  onCancelClicked: PropTypes.func,
  onNextClicked: PropTypes.func,
  registerError: PropTypes.string,
  onCloseModal: PropTypes.func,
  translations: PropTypes.shape({
    register_password_title_label: PropTypes.string,
    register_password_description_label: PropTypes.string,
    register_password_option_button_next: PropTypes.string,
    register_password_option_button_cancel: PropTypes.string,
    password_tooltip_completeField_label_validation: PropTypes.string,
    password_tooltip_title_label: PropTypes.string,
    password_tooltip_letter_label_validation: PropTypes.string,
    password_tooltip_number_label_validation: PropTypes.string,
    password_tooltip_length_label_validation: PropTypes.string,
  }),
  asset: PropTypes.shape({
    home_ticker_icon_button_close: PropTypes.string,
    mail_modal_icon_warning: PropTypes.string,
  }),
};

export default PasswordForm;
